import { z } from 'zod';
export const FilterRule = z.object({
    id: z.string().uuid(),
    tenantId: z.string().uuid(),
    /** Whitespace-separated tokens; sequential match against message text. */
    pattern: z.string().min(1),
    enabled: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CreateFilterRuleRequest = z.object({
    pattern: z.string().min(1).max(256),
});
export const UpdateFilterRuleRequest = z
    .object({
    pattern: z.string().min(1).max(256).optional(),
    enabled: z.boolean().optional(),
})
    .refine((v) => v.pattern !== undefined || v.enabled !== undefined, {
    message: 'at least one of pattern / enabled must be provided',
});
/**
 * In-memory sample of a message that PASSED filters. Used by admin UI
 * to surface recurring spam for easy keyword extraction. Lost on restart.
 */
export const MessageSample = z.object({
    text: z.string(),
    count: z.number().int().positive(),
    lastSeenAt: z.string().datetime(),
    lastGroupTitle: z.string().nullable(),
});
//# sourceMappingURL=filter.js.map